// @flow
import * as React from 'react';
import { Button, Box } from '@locus-taxy/neo-ui';

export class NeoButton extends React.PureComponent<
    React.ElementConfig<typeof Button>
> {
    render() {
        const { disabled, sx } = this.props;
        const buttonStyles = { ...(sx || {}) };
        const cursorStyles = { display: 'inline-block' };
        if (disabled) {
            buttonStyles.pointerEvents = 'none';
            cursorStyles.cursor = 'not-allowed';
        }
        return (
            <Box sx={cursorStyles}>
                <Button {...this.props} sx={buttonStyles} />
            </Box>
        );
    }
}
